
import React, { useEffect } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { translations } from '../../../configs/translations'
import { UserProfile } from '../../../models/UserProfile'
import UserService from '../../../services/UserService'
import { useStore } from '../../../store/store'
import { formatTextWithParams } from '../../../utils/formatTextWithParams'
import './Subscriptions.css'

export interface SubscriptionsProps {
    setModuleWindowOpen: (open: boolean) => void
    setModuleWindowText: (text: string) => void
    setModuleWindowTitle: (title: string) => void
    isAccepted: boolean
    setProfile: React.Dispatch<React.SetStateAction<UserProfile | null>>
}

export const Subscriptions = ({
    setModuleWindowOpen,
    setModuleWindowText,
    setModuleWindowTitle,
    isAccepted,
    setProfile
}: SubscriptionsProps) => {
    const language = useStore(state => state.language) as keyof typeof translations
    const t = translations[language]
    const [type, setType] = React.useState('')
    const [days, setDays] = React.useState(30)

    const subscribe = async (type: string, days: number) => {
        await UserService.subscribe(type, days)
            .then(() => {
                const audio = new Audio('./sounds/buy.mp3')
                audio.play()
                setProfile(null)
            })
            .catch((error) => {

                if (error?.response?.data === 'already_subscribed') {
                    toast(t.already_subscribed, {
                        className: 'notification-warning',
                        icon: '⚠️',
                    })
                    return
                }

                toast.error(
                    error && error.response && error.response.data && t[error.response.data as keyof typeof t]
                        ? t[error.response.data as keyof typeof t]
                        : t.error_unknown,
                    { className: 'notification-error' }
                )
            })
    }

    const getText = (days: number, price: number) => {
        return formatTextWithParams(t.donate_subscribe_text, [days.toString(), price.toString()])
    }

    const handleBuy = (type: string, price: number, days: number) => {
        setModuleWindowOpen(true)
        setModuleWindowText(getText(days, price))
        setModuleWindowTitle(t.donate_subscribe_title)
        setType(type)
        setDays(days)
    }

    useEffect(() => {
        if (isAccepted && type) {
            subscribe(type, days)
            setType('')
            setModuleWindowOpen(false)
        }
    }, [isAccepted, type])

    return (
        <div className="subscriptions-container">

            <div className='subscription-item light'>
                <div className='subscription-content-block-wrapper'>
                    <div className='subscription-content-block'>
                        <div className='subscription-header-logo'>
                            <img src="./icons/128px/light.png" alt="light" />
                        </div>
                    </div>
                </div>

                <div className='subscription-content-block-wrapper'>
                    <div className='subscription-content-block'>
                        <div className='subscription-content-title'>
                            <h1>{t.sub_light}</h1>
                        </div>
                        <div className='subscription-content-description'>
                            <p>{t.sub_light_description}</p>
                        </div>
                    </div>
                </div>

                <div className='subscription-content-block-wrapper'>
                    <div className='subscription-content-block'>
                        <div className='subscription-benefits' style={{ height: '250px' }}>
                            <ul>
                                <li>{t.sub_light_benefit_1}</li>
                                <li>{t.sub_light_benefit_2}</li>
                                <li>{t.sub_light_benefit_3}</li>
                                <li>{t.sub_light_benefit_4}</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className='subscription-content-block-wrapper'>
                    <div className='subscription-content-block' style={{ borderBottom: 'none' }}>
                        <div className='subscription-price'>
                            <h1>{t.price}: 499</h1>
                            <img src="./icons/32px/dp.png" alt="dp" />
                        </div>

                        <div className="subscription-buy-button-container">
                            <div
                                onClick={() => {
                                    setType('premium_account')
                                    handleBuy('premium_account', 499, 30)
                                }}
                                className="subscription-buy-button-button"
                            >
                                <p>{t.subscribe}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <Toaster
                position="bottom-center"
                toastOptions={{
                    duration: 2000
                }}
            />
        </div>
    )
}